import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { CatalogoService } from 'src/app/aplicaciones-modulos/distribuidores/services/catalogo.service';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import {
  LfsaBotonEditarGridComponent
} from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { IndicadoresVivosVModel } from '../../models/indicadoresVivosVModel';
import { CatalogoIndicadoresService } from '../../services/catalogo-indicadores.service';
import { CargaMetaIncentivoSellOutService } from '../../services/carga-meta-incentivo-sell-out.service';
import { comisionesModulo } from '../../diccionarios/comisionesModulo';
import { TipoDeVendedorService } from '../../services/tipo-de-vendedor.service';
import { AltaDeVendedoresService } from '../../services/alta-de-vendedores.service';

@Component({
  selector: 'app-carga-meta-incentivo-sell-out',
  templateUrl: './carga-meta-incentivo-sell-out.component.html',
  styleUrls: ['./carga-meta-incentivo-sell-out.component.css']
})

export class CargaMetaIncentivoSellOutComponent implements OnInit {

  titulo = 'Carga Venta Sell Out';
  mostrarFormulario = false;

  textoBuscar = '';
  gridApi: any;
  gridColumnApi: any;
  columnDefs: any[];
  columnDefsCarteras: any[];
  frameworkComponents: any;
  rowSelection: any;
  rowData: any[] = [];

  @ViewChild('fileInput') fileInput: ElementRef;
  formulario: FormGroup;

  loading: boolean = false;
  listaVacia: boolean = true;

  modulo: any = {};

  DAT_BTNS: any;
  DAT_MSG: any;
  DAT_BTNCSS: any;

  rowDataCarteras: any[] = [];

  modelGrid: any;
  csv: string;
  objSelected: any = {};
  listaVaciaCli: boolean = true;
  errorData: boolean = true;
  cmbOpciones: { clave: number; valor: string; }[];

  constructor(
    public fb: FormBuilder,
    private _util: UtilsService,
    private catalogo: CatalogoService,
    private _tipoDeVendedor: TipoDeVendedorService,
    private _altaDeVendedor: AltaDeVendedoresService,
    private _serviciosCRUD: CargaMetaIncentivoSellOutService,
  ) { }

  ngOnInit() {

    this.formulario = this.fb.group({
      tipoVendedorId: ['', [Validators.required]],
      vendedorId: ['', []],
      multipart: ['', [Validators.required]],
    });

    const innClase = new IndicadoresVivosVModel();
    this.modelGrid = innClase.devolverGricargaMetaIncentivoSellOut();

    this.modulo = comisionesModulo;
    this.DAT_BTNS = this.modulo.button.buttonsNombre;
    this.DAT_MSG = this.modulo.mensajes;
    this.DAT_BTNCSS = this.modulo.button.buttonsCss;
    this.cargarIconosFiltros();
    this.cargarGrid();

    this.formulario.get('multipart').valueChanges
      .subscribe((resp) => {
        this.getFormValidationErrors();
      });

    this.formulario.get('tipoVendedorId').valueChanges
      .subscribe((resp) => {
        this.getVendedores(resp);
      });

    this.getTiposDeVendedores();
    this.getTodo();
    this.cargarGridCarteras();

  }

  listDeVendedores;
  getVendedores(tipo) {
    this.loading = true;
    this._altaDeVendedor.getTodoPorTipo(tipo).subscribe((res: any[]) => {
      console.log("getVendedores()", res)
      this.loading = false;
      this.listDeVendedores = res;
    }, (err) => {
      this.loading = false;
      this.listDeVendedores = [];
    });
  }

  listTiposDeVendedores;
  getTiposDeVendedores() {
    this.loading = true;
    this._tipoDeVendedor.getTiposDeVendedoresPorEstado("1").subscribe((res: any[]) => {
      console.log("getTiposDeVendedores()", res)
      this.loading = false;
      this.listTiposDeVendedores = res;
    }, (err) => {
      this.loading = false;
      this.listTiposDeVendedores = [];
    });
  }

  /** FUNCIONES */
  getTodo() {
    this.listaVacia = true;
    this.loading = true;

    this._serviciosCRUD.getTodo().subscribe((res: any[]) => {
      console.log("getTodo()", res)
      this.loading = false;
      this.listaVacia = (res.length === 0) ? true : false;
      this.rowDataCarteras = res;
    }, (err) => {
      this.loading = false;
      this.listaVacia = true;
      this.rowDataCarteras = [];
    });
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  onQuickFilterChanged() {
    this.gridApi.setQuickFilter(this.textoBuscar);
  }

  cargarIconosFiltros() {
    this.csv = this.catalogo.catalogoAsesorIcon().csv;
  }

  changeRowColor(params) {
    let data = params.data;
    if (data.correct != undefined) {
      if (data.correct === true) {
        return {
          'background-color': 'lightgreen',
          'color': 'black',
          'font-weight': 'bold',
          'font-size': '14px'
        };
      }
      else {
        return {
          'background-color': '#FFC0CB',
          'color': 'black',
          'font-weight': 'bold',
          'font-size': '14px'
        };
      }
    }
    return true;
  }

  cargarGrid() {
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.columnDefs = [
      {
        headerName: 'ESTADO',
        sortable: true,
        filter: true,
        width: 200,
        cellStyle: this.changeRowColor.bind(this),
        valueGetter: function (params: any) {
          return (params.data.correct === true) ? 'CORRECTO' : 'INCORRECTO';
        }
      },
      {
        headerName: 'Código de Vendedor',
        field: this.modelGrid.codigoVendedor,
        filter: true,
        width: 200,
        sortable: true
      },
      {
        headerName: 'Vendedor',
        field: this.modelGrid.nombreVendedor,
        filter: true,
        width: 500,
        sortable: true
      },
      {
        headerName: '# Clientes',
        field: this.modelGrid.nclientes,
        filter: true,
        width: 200,
        sortable: true
      },
      {
        headerName: 'Kilos',
        field: this.modelGrid.kilos,
        filter: true,
        width: 200,
        sortable: true
      },
      {
        headerName: 'Cajas',
        field: this.modelGrid.cajas,
        filter: true,
        width: 200,
        sortable: true
      },
      {
        headerName: 'Ventas',
        field: this.modelGrid.ventas,
        filter: true,
        width: 200,
        sortable: true
      },
      {
        headerName: 'Año',
        field: this.modelGrid.anio,
        filter: true,
        width: 200,
        sortable: true
      },
      {
        headerName: 'Mes',
        field: this.modelGrid.mesDescripcion,
        filter: true,
        width: 200,
        sortable: true
      },
      {
        headerName: 'ERROR',
        field: 'error.errorCampo',
        cellStyle: this.changeRowColor.bind(this),
        filter: true,
        width: 600,
        sortable: true
      },
    ];
    this.rowSelection = 'multiple';
  }

  regresar() {
    this.mostrarFormulario = false;
    this.rowData = [];
    this.formulario.reset();
  }

  onFileSelect(event) {
    let allowedExtensions = /(.csv)$/i;
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      if (!allowedExtensions.exec(file.name)) {
        this.formulario.get('multipart').setValue('');
        this._util.mensajeErrorVisto('El tipo de archivo no es valido, el tipo de archivo permitido es "CSV" ', true, 9000);
        this.fileInput.nativeElement.value = '';
      } else {
        this.formulario.get('multipart').setValue(file);
      }
    }
  }

  setFormData(data: any): FormData {
    const formData = new FormData();
    formData.append('file', new Blob([data.multipart], { type: 'text/csv' }), 'file');
    return formData;
  }

  validarRowData() {
    this.errorData = true;
    this.rowData.forEach(e => {
      if (e.correct) {
        this.errorData = false;
      }
    });
  }

  enviarFormulario() {

    let vendedores = this.formulario.get('vendedorId').value;
    let tipoDeVendedor = this.formulario.get('tipoVendedorId').value;

    this._util.confirmarSincronoPromesaNormal(
      {
        title: 'Esta seguro que desea enviar el siguiente archivo?',
        text: vendedores == null ? 'Se procesará para todos los vendedores parte del canal' : 'Se procesará para el vendedor ' + vendedores,
        action: 'Enviar',
        funcion: this._serviciosCRUD.procesarCsv(this.setFormData(this.formulario.value), tipoDeVendedor, vendedores),
        loading: true,
        context: this,
      }
    ).then((res: any[]) => {
      console.log("enviarFormulario()", res);
      // debugger
      this.mostrarFormulario = true;
      this.rowData = res;
      if (this.rowData.length > 0) {
        this.listaVacia = false;
        this.validarRowData();
      } else {
        this.listaVacia = true;
      }
    }).catch((err) => {
      console.log('Error ' + err);
      this.rowData = [];
      this.listaVacia = true;
    });
  }

  guardar() {
    this._util.confirmarSincronoPromesaNormal(
      {
        title: 'Esta seguro que desea guardar el siguiente listado?',
        text: '',
        action: 'Guardar',
        funcion: this._serviciosCRUD.saveCsv(this.rowData),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      this.getTodo();
      this._util.mensajeOKVisto(res, true, 10000);
      // this.downloadDataCsv();
      this.regresar();
    }).catch((err) => {
      console.log('Error ' + err);
      this._util.mensajeErrorVisto(err.error.message, true, 3000);
    });
  }

  downloadCsvFormato() {
    let cabecera: any[] = [['COD.VENDEDOR', 'N#CLIENTES','KILOS INVENTARIO ACTIVO','VENTAS EFECTIVAS', 'CAJAS', 'AÑO', 'MES']];
    const data: any[] = [
      { 'mesInicio': '400000309', 'mesFin': '121', 'vendedor': 121212, 'valINI': 3434 , 'cajas': 265, 'anio': 2024 , 'mes': 1 }
    ];
    let name: string = "formato-plantilla.csv";
    this._util.exportCSV(cabecera, data, name);
  }

  downloadDataCsv() {
    console.log("this.rowData", this.rowData)
    let data: any = [];
    let cabecera: any[] = [['idMetasIncentivo', 'anio', 'mes', 'tipoVendedorId', 'codigoVendedor', 'kilos', 'ventas', 'cajas',
      'nclientes', 'tipoVendedorDescripcion', 'nombreVendedor', 'mesDescripcion', 'estado', 'linea', 'error']];
    let clonData = this.rowData.map((x) => Object.assign({}, x));
    clonData.forEach((e) => {
      if (!e.correct) {
        data.push(
          {
            idMetasIncentivo: !(e.idMetasIncentivo) ? '' : e.idMetasIncentivo,
            anio: !(e.anio) ? '' : e.anio,
            mes: !(e.mes) ? '' : e.mes,
            tipoVendedorId: !(e.tipoVendedorId) ? '' : e.tipoVendedorId,
            codigoVendedor: !(e.codigoVendedor) ? '' : e.codigoVendedor,
            kilos: !(e.kilos) ? '' : e.kilos,
            ventas: !(e.ventas) ? '' : e.ventas,
            cajas: !(e.cajas) ? '' : e.cajas,
            nclientes: !(e.nclientes) ? '' : e.nclientes,
            tipoVendedorDescripcion: !(e.tipoVendedorDescripcion) ? '' : e.tipoVendedorDescripcion,
            nombreVendedor: !(e.nombreVendedor) ? '' : e.nombreVendedor,
            mesDescripcion: !(e.mesDescripcion) ? '' : e.mesDescripcion,
            estado: (e.correct) ? 'CORRECTO' : 'INCORRECTO',
            linea: (e.error === undefined) ? '' : e.error.linea,
            errorCampo: (e.error === undefined) ? '' : e.error.errorCampo,
          }
        );
      }
    });
    let name: string = "REGISTRO_ERRORES.csv";
    this._util.exportCSV(cabecera, data, name);
    // this._util.mensajeOKToast('El archivo csv se exporto correctame.');
  }

  setCodigoArticulo({ codigoArticulo, contenedor }) {
    if (codigoArticulo !== undefined && contenedor !== undefined && contenedor !== "") {
      return `${codigoArticulo}/${contenedor}`
    } else {
      if (codigoArticulo !== undefined) {
        return `${codigoArticulo}`;
      } else {
        return '';
      }
    }
  }

  getFormValidationErrors() {

    console.log('%c ==>> Validation Errors: ', 'color: red; font-weight: bold; font-size:25px;');

    let totalErrors = 0;

    Object.keys(this.formulario.controls).forEach(key => {
      const controlErrors: ValidationErrors = this.formulario.get(key).errors;
      if (controlErrors != null) {
        totalErrors++;
        Object.keys(controlErrors).forEach(keyError => {
          console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
        });
      }
    });

    console.log('Number of errors: ', totalErrors);
  }

  cargarGridCarteras() {
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };
    this.columnDefsCarteras = [
      {
        headerName: 'Id',
        field: 'idMetasIncentivo',
        filter: true,
        sortable: true,
        width: 50,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Año',
        field: 'anio',
        sortable: true,
        width: 100,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Mes',
        field: 'mesDescripcion',
        sortable: true,
        width: 150,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Tipo de Vendedor',
        field: 'tipoVendedorDescripcion',
        sortable: true,
        width: 350,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Nombre Vendedor',
        field: 'nombreVendedor',
        sortable: true,
        width: 350,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      }, {
        headerName: 'Cajas',
        field: 'cajas',
        sortable: true,
        width: 100,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Kilos',
        field: 'kilos',
        sortable: true,
        width: 100,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      }, {
        headerName: 'Ventas',
        field: 'ventas',
        sortable: true,
        width: 100,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      }, {
        headerName: '# de Clientes',
        field: 'nclientes',
        sortable: true,
        width: 120,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      // {
      //   headerName: '',
      //   cellRenderer: 'buttonRenderer',
      //   width: 150,
      //   cellRendererParams: {
      //     onClick: this.editar.bind(this),
      //     label: this.DAT_BTNS.editar,
      //     colorBoton: this.DAT_BTNCSS.warning
      //   }
      // },
      // {
      //   headerName: '',
      //   cellRenderer: 'buttonRenderer',
      //   width: 150,
      //   cellRendererParams: {
      //     onClick: this.eliminar.bind(this),
      //     label: this.DAT_BTNS.eliminar,
      //     colorBoton: this.DAT_BTNCSS.danger
      //   }
      // },
    ];

    this.rowSelection = 'multiple';
  }

}
